module.exports = __webpack_public_path__ + "img/paid.d01efd20.png";